import { render, staticRenderFns } from "./DashboardShopify.vue?vue&type=template&id=301570dc&"
import script from "./DashboardShopify.vue?vue&type=script&lang=js&"
export * from "./DashboardShopify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports